var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 184,
    viewBox: "0 0 184 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_503_8110)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_503_8110",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 184,
    height: 184
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M184 92C184 41.1898 142.81 0 92 0C41.1898 0 0 41.1898 0 92C0 142.81 41.1898 184 92 184C142.81 184 184 142.81 184 92Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_503_8110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.601 31.1022C150.543 -14.6812 87.4399 -25.8079 41.6565 6.24996C-4.12692 38.3078 -15.2536 101.411 16.8042 147.194C48.8621 192.977 111.965 204.104 157.748 172.046C203.532 139.988 214.659 76.8856 182.601 31.1022Z",
    fill: "#9E73B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6909 104.063C67.3197 108.263 77.503 107.373 87.2409 101.39",
    stroke: "#262626",
    strokeWidth: 5.76036,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8457 66.0443C58.4029 60.9826 54.9664 57.1485 51.1701 57.4807C47.3739 57.8128 44.6554 62.1853 45.0982 67.247C45.5411 72.3087 48.9775 76.1428 52.7738 75.8106C56.5701 75.4785 59.2885 71.106 58.8457 66.0443Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.395 63.3714C88.9522 58.3097 85.5157 54.4757 81.7194 54.8078C77.9232 55.1399 75.2047 59.5125 75.6475 64.5742C76.0904 69.6359 79.5268 73.4699 83.3231 73.1378C87.1194 72.8057 89.8379 68.4331 89.395 63.3714Z",
    fill: "#262626"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_503_8110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 184,
    height: 184,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgProfile);
export default __webpack_public_path__ + "static/media/Img_profile.a49610cb18ceac1a9a7a868ae911a44c.svg";
export { ForwardRef as ReactComponent };